/*
 * @version: v 1.0.0
 * @Github: https://github.com/GitHubGanKai
 * @Author: GitHubGanKai
 * @Date: 2021-01-01 17:19:50
 * @LastEditors: gankai
 * @LastEditTime: 2021-01-02 20:35:02
 * @FilePath: /refactor-with-vue3/src/store/index.js
 */

import { createStore } from 'vuex'

import cart from './modules/cart'
import search from './modules/search'

export default createStore({
  state: {
    menu_lists: []  //菜单
  },
  getters: {
    account(state) {
      return state.menu_lists  // 读取菜单列表
    }
  },
  mutations: {
    // 增加菜单
    menuAdd(state, n) {
      if (state.menu_lists.length == 0) {
        state.menu_lists.push(n)
      } else {
        if (state.menu_lists.some(menu => menu.name != n.name)) {
          state.menu_lists.push(n)
        }
      }
    },
    // 清空菜单
    menuDelect(state) {
      state.menu_lists.length = 0
    }
  },
  actions: {
    menu_add({ commit }, data) {
      commit('menuAdd', data)
    },
    // 登出时调用将菜单数据删除
    menu_delect({ commit }) {
      commit('menuDelect')
    }
  },
  modules: {
    cart,
    search
  },
  strict: process.env.NODE_ENV !== 'production'
})
